import type { TimeProvider } from '@ai-swfactory/seams/interfaces'
import { FC, useMemo } from 'react'
import { Create, type RaRecord, useRecordContext, useRecordFromLocation } from 'react-admin'

import { BackButton } from '@/components/molecules/BackButton'
import { SpecialEventForm } from '@/components/molecules/SpecialEventForm'
import { useEventRecord, useScaleEvents } from '@/components/molecules/useScaleEvents'
import { specialEventDefaultStart } from '@/data'
import type { EventRecord } from '@/data/source'
import { useClock } from '@/lib/clock'

export const toScale = (_resource?: string, _id?: unknown, data?: Partial<RaRecord>): string => `scales/${String(data?.scaleRecordId)}/show`

export const BackToScale: FC = () => {
  const fromLocation = useRecordFromLocation()
  const record = useRecordContext() ?? fromLocation
  if (typeof record?.scaleRecordId !== 'string') return null
  return <BackButton to={`/${toScale(undefined, undefined, record)}`} label="resources.scale_events.actions.back_to_scale" />
}

const defaultStart = (events: readonly EventRecord[], clock: TimeProvider) => (): Record<string, unknown> => {
  const now = new Date(clock.timestamp())
  now.setSeconds(0, 0)
  const start = specialEventDefaultStart(events, now.getTime())
  return start === null ? {} : { startTime: new Date(start).toISOString() }
}

const PrefilledSpecialEventForm: FC = () => {
  const record = useEventRecord()
  const events = useScaleEvents(record?.scaleRecordId)
  const clock = useClock()
  const defaultValues = useMemo(() => (events === undefined ? undefined : defaultStart(events, clock)), [events, clock])
  return defaultValues === undefined ? null : <SpecialEventForm defaultValues={defaultValues} />
}

export const SpecialEventCreate = () => (
  <Create title="resources.scale_events.title_create" redirect={toScale} actions={<BackToScale />}>
    <PrefilledSpecialEventForm />
  </Create>
)
